import { dataTableEvents } from 'src/app/core/constants/data-table-events';

function atLeastOneSelectedOnCurrentPage(currentPageDataIds: any[], selectedIds: any[]): boolean {
  return currentPageDataIds.some((item: any) => selectedIds.includes(item));
}

function allSelectedOnCurrentPage(currentPageDataIds: any[], selectedIds: any[]): boolean {
  return currentPageDataIds.length > 0 && currentPageDataIds.every((val) => selectedIds.includes(val));
}

function getTableElement(
  apiInstance?: DataTables.Api,
  target?: EventTarget | null,
): HTMLTableElement | null {
  const tableNode = (apiInstance as any)?.table?.().node?.();

  if (tableNode instanceof HTMLTableElement) {
    return tableNode;
  }

  if (target instanceof Element) {
    const targetTable = target.closest('table');

    if (targetTable instanceof HTMLTableElement) {
      return targetTable;
    }
  }

  return null;
}

function getCurrentPageDataIds(
  apiInstance: DataTables.Api | undefined,
  selectFieldName: string,
): string[] {
  return (
    apiInstance
      ?.rows({ page: 'current' })
      .data()
      .toArray()
      .map((item: any) => item[selectFieldName]?.toString())
      .filter((item: string | undefined): item is string => !!item) || []
  );
}

function processThreeDotsMenu(event: any) {
  const menus = document.getElementsByClassName('dropdown-content');

  for (let i = 0; i < menus.length; i++) {
    menus[i].classList.remove('show');
  }

  if (event.target.id === 'threeDots') {
    if (event.target.nextSibling.nextSibling.classList.contains('show')) {
      event.target.nextSibling.nextSibling.classList.remove('show');
    } else {
      event.target.nextSibling.nextSibling.classList.toggle('show');
    }
  }
}

function processSelectItemClick(event: any, selectedIds: string[]): string[] {
  const itemId = event.target.getAttribute(dataTableEvents.common.checkedId);

  if (event.target.checked) {
    selectedIds = [...selectedIds, itemId];
  } else {
    selectedIds = selectedIds.filter((id: string) => {
      return id !== itemId;
    });
  }

  return selectedIds;
}

function processSelectAllClick(
  event: any,
  selectedIds: string[],
  apiInstance: DataTables.Api | undefined,
  selectFieldName: string,
): string[] {
  const tableElement = getTableElement(apiInstance, event.target);
  const selectedIdsOnCurrentPage = getCurrentPageDataIds(apiInstance, selectFieldName);

  if (!tableElement || selectedIdsOnCurrentPage.length === 0) {
    return selectedIds;
  }

  tableElement.querySelectorAll('tbody input#selectItem').forEach((item) => {
    (item as HTMLInputElement).checked = event.target.checked;
  });

  if (event.target.checked === true) {
    selectedIds = [...new Set([...selectedIds, ...selectedIdsOnCurrentPage])];
  } else {
    selectedIds = selectedIds.filter((id: string) => {
      return !selectedIdsOnCurrentPage.includes(id);
    });
  }

  return selectedIds;
}

function selectCheckBoxesRelatedToSelectedIds(selectedIds: string[]): void {
  const tables = document.querySelectorAll('table.dataTable');

  tables.forEach((table) => {
    table.querySelectorAll('tbody input#selectItem').forEach((item) => {
      (item as HTMLInputElement).checked = selectedIds.includes(
        item.getAttribute(dataTableEvents.common.checkedId) || '',
      );
    });
  });
}

function processSelectLogic(
  apiInstance: DataTables.Api | undefined,
  selectFieldName: string,
  selectedIds: string[],
): void {
  const tableElement = getTableElement(apiInstance);
  const currentPageDataIds = getCurrentPageDataIds(apiInstance, selectFieldName);
  const selectAllCheckbox = tableElement?.querySelector('thead input#selectAll');

  if (!selectAllCheckbox) {
    return;
  }

  if (currentPageDataIds.length === 0) {
    (selectAllCheckbox as HTMLInputElement).indeterminate = false;
    (selectAllCheckbox as HTMLInputElement).checked = false;
    selectCheckBoxesRelatedToSelectedIds(selectedIds);
    return;
  }

  if (allSelectedOnCurrentPage(currentPageDataIds, selectedIds)) {
    (selectAllCheckbox as HTMLInputElement).indeterminate = false;
    (selectAllCheckbox as HTMLInputElement).checked = true;
  } else if (atLeastOneSelectedOnCurrentPage(currentPageDataIds, selectedIds)) {
    (selectAllCheckbox as HTMLInputElement).checked = false;
    (selectAllCheckbox as HTMLInputElement).indeterminate = true;
  } else {
    (selectAllCheckbox as HTMLInputElement).indeterminate = false;
    (selectAllCheckbox as HTMLInputElement).checked = false;
  }

  selectCheckBoxesRelatedToSelectedIds(selectedIds);
}

export {
  atLeastOneSelectedOnCurrentPage,
  allSelectedOnCurrentPage,
  processThreeDotsMenu,
  processSelectItemClick,
  processSelectAllClick,
  selectCheckBoxesRelatedToSelectedIds,
  processSelectLogic,
};
